import { render, staticRenderFns } from "./listSensorsTankCustomer.vue?vue&type=template&id=7965eae4&scoped=true&"
import script from "./listSensorsTankCustomer.vue?vue&type=script&lang=js&"
export * from "./listSensorsTankCustomer.vue?vue&type=script&lang=js&"
import style0 from "./listSensorsTankCustomer.vue?vue&type=style&index=0&id=7965eae4&prod&lang=css&"
import style1 from "./listSensorsTankCustomer.vue?vue&type=style&index=1&id=7965eae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965eae4",
  null
  
)

export default component.exports